const fail = () => {
  throw new Error("Page name is not defined");
};
const getPageName = ({ pageName }, fallback) => {
  return pageName ?? fallback ?? fail();
};
export {
  getPageName
};
//# sourceMappingURL=getPageName.js.map
